import { NotFound } from "../page-components/not-found";

export default NotFound;
